import Common from '../wp-controlers/common-panel/geralAttributes';

export default {
  containerized: {
    type: 'boolean',
    default: true,
  },
  image: {
    type: 'object',
    default: {
      id: '',
      src: '',
      alt: '',
    },
  },
  title: {
    type: 'string',
    default: 'Por que escolher a Sumicity?',
  },
  button: {
    type: 'string',
    default: '',
  },
  hrefLink: {
    type: 'string',
  },
  hideButton: {
    type: 'boolean',
    default: false,
  },
  imagePosition: {
    type: 'string',
    default: 'right',
  },
  space: {
    type: 'string',
    default: 'large',
  },
  addTitle: {
    type: 'boolean',
    default: true,
  },
  addImage: {
    type: 'boolean',
    default: true,
  },
  addButton: {
    type: 'boolean',
    default: true,
  },
  ...Common,
};
